<div class="label-container">
  <div {{#if theme_class}}class="{{theme_class}}"{{/if}}>
    <label {{#if text_class}}class="{{text_class}}"{{/if}} 
      tabindex="0" aria-label="{{t prefix}}{{t description}}">
        {{t prefix}}{{t description}}
    </label>
  </div>
</div>